package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.wallpapercrud.add.WallpaperAddPage

@InitRoute
fun initWallpaperAddRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Add Wallpapers"))
}

@Page(routeOverride = "wallpaperadd")
@Layout(".components.layouts.PageLayout")
@Composable
fun WallpaperAddRoute() {
    WallpaperAddPage()
}
